import { QuestionItemTypeEnum, QuestionItemV2, StemCoordinates } from '@examdojo/models/question';
import { ActiveQuestionEditorCoordinates } from '../question-items-editor/question-item-editor.model';

export function getContentJsonPathFromCoordinates(coordinates: ActiveQuestionEditorCoordinates): string {
  const segments: string[] = ['$'];

  segments.push(`[${coordinates['rootItemIndex']}]`);

  if ('stems' in coordinates && typeof coordinates['stems'] === 'number') {
    segments.push(`.stems[${coordinates['stems']}]`);
  }

  if ('markscheme.all_mark_groups' in coordinates) {
    const idx = coordinates['markscheme.all_mark_groups'];
    segments.push(`.markscheme.all_mark_groups[${idx}]`);

    if ('criterion' in coordinates && typeof coordinates['criterion'] === 'number') {
      segments.push(`.criterion[${coordinates['criterion']}]`);
    }
  } else if ('markscheme.solution_paths' in coordinates) {
    const idx = coordinates['markscheme.solution_paths'];
    segments.push(`.markscheme.solution_paths[${idx}]`);

    if ('worked_solution' in coordinates && typeof coordinates['worked_solution'] === 'number') {
      segments.push(`.worked_solution[${coordinates['worked_solution']}]`);
    }
  }

  if ('options' in coordinates && typeof coordinates['options'] === 'number') {
    segments.push(`.options[${coordinates['options']}]`);
  }

  if ('content_items' in coordinates && typeof coordinates['content_items'] === 'number') {
    segments.push(`.content_items[${coordinates['content_items']}]`);
  }

  return segments.join('');
}

export function collectStemFormKeysFromQuestionItems(items: QuestionItemV2[]): string[] {
  const keys: string[] = [];
  items.forEach((item, index) => {
    if (item.type === QuestionItemTypeEnum.Stem) {
      keys.push(getContentJsonPathFromCoordinates({ rootItemIndex: index }));
    }

    if (item.type === QuestionItemTypeEnum.StemGroup) {
      item.stems.forEach((_, stemIndex) => {
        keys.push(getContentJsonPathFromCoordinates({ rootItemIndex: index, stems: stemIndex }));
      });
    }
  });
  return keys;
}

export function getStemCoordinatesFromJsonPath(jsonPath: string): StemCoordinates | null {
  const segments = jsonPath.split('.');

  const rootItemMatch = segments[0].match(/^\$\[(\d+)\]$/);
  if (!rootItemMatch) {
    return null;
  }

  let coordinates: StemCoordinates = {
    rootItemIndex: parseInt(rootItemMatch[1]),
  };

  if (segments.length > 1 && segments[1].startsWith('stems[')) {
    const stemMatch = segments[1].match(/^stems\[(\d+)\]$/);
    if (stemMatch) {
      coordinates = {
        ...coordinates,
        stems: parseInt(stemMatch[1]),
      };
    }
  }

  return coordinates;
}
